import { Box, Button, styled, TextField } from "@mui/material";
import theme from "../../theme";

export const AddressInput = styled(TextField)`
  background-color: ${theme.palette.common.white};
  text-overflow: ellipsis;
  width: 400px;
  padding: 0;
  border-radius: 4px;
  border: 1px solid ${theme.palette.secondary.main};
  margin-right: 10px;
`;

export const AddressWrapper = styled(Box)`
  margin: 10px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
`;

export const SelectAddressButton = styled(Button)`
  &.Mui-disabled {
    background-color: ${theme.palette.grey[300]};
  }
`;
